import React, { useState } from 'react'
import styles from './NewSlider.module.css'
import arrowLeft from '../../assets/icons/arrowLeft.svg'

interface Slide {
  id: number
  src: string
}

interface SliderProps {
  slides: Slide[]
}

const NewSlider: React.FC<SliderProps> = ({ slides }) => {
  const [currentIndex, setCurrentIndex] = useState(0)
  const [thumbnailOffset, setThumbnailOffset] = useState(0)

  const goToSlide = (index: number) => {
    setCurrentIndex(index)
  }

  const nextSlide = () => {
    const newIndex = (currentIndex + 1) % slides.length
    goToSlide(newIndex)
  }

  const prevSlide = () => {
    const newIndex = (currentIndex - 1 + slides.length) % slides.length
    goToSlide(newIndex)
  }

  const nextThumbnails = () => {
    const newOffset = Math.min(thumbnailOffset + 1, slides.length - 4)
    setThumbnailOffset(newOffset)
  }

  const prevThumbnails = () => {
    const newOffset = Math.max(thumbnailOffset - 1, 0)
    setThumbnailOffset(newOffset)
  }

  return (
    <div className={styles.container}>
      {/* Main slide */}
      <div className={styles.mainSlide}>
        <img
          src={slides[currentIndex].src}
          alt={`Slide ${slides[currentIndex].id}`}
          className={styles.mainImage}
        />
      </div>

      {/* Thumbnails */}
      <div className={styles.thumbnailsContainer}>
        <button
          className={`${styles.arrowButton} ${
            thumbnailOffset === 0 ? styles.arrowButtonDisabled : ''
          }`}
          onClick={prevThumbnails}
          disabled={thumbnailOffset === 0}
        >
          <img src={arrowLeft} />
        </button>

        <div className={styles.thumbnails}>
          {slides.slice(thumbnailOffset, thumbnailOffset + 4).map((slide, index) => {
            const originalIndex = thumbnailOffset + index
            const isActive = originalIndex === currentIndex

            return (
              <div
                key={slide.id}
                className={isActive ? styles.thumbnailActive : styles.thumbnail}
                onClick={() => goToSlide(originalIndex)}
              >
                <img
                  src={slide.src}
                  alt={`Thumbnail ${slide.id}`}
                  className={styles.thumbnailImage}
                />
              </div>
            )
          })}
        </div>

        <button
          className={`${styles.arrowButton} ${
            thumbnailOffset >= slides.length - 4 ? styles.arrowButtonDisabled : ''
          }`}
          onClick={nextThumbnails}
          disabled={thumbnailOffset >= slides.length - 4}
        >
          <img className={styles.right} src={arrowLeft} />
        </button>
      </div>
    </div>
  )
}

export default NewSlider
